import { APIEvent } from '../events/apiEvent'
import { StatusBarEvent } from '../events/statusBarEvent'
import { EventBus } from '../event-bus'
import { JSONToCSVConvertor, createReportLabel } from '../utils'
export default {

  data: function () {
    return {
      incompleteInstallsList: [],
      startOffset: 0,
      currentPage: 1,
      hasNextPage: false,
      requestData: null,
      perPage: 20,
      pageNumber: 1,
      searchString: '',
      errorString: '',
      searchInput: '',
      statusSelection: null,
      typeSearch: null,
      errorMessage: '',
      selectedUser: {},
      searchType: [
        {text: 'Select search type', value: null},
        {text: 'Email Address', value: 'username'},
        {text: 'First Name', value: 'first_name'},
        {text: 'Last Name', value: 'last_name'},
        {text: 'Country', value: 'country'}
      ],
      pageOptions: [
        {text: 5, value: 5},
        {text: 10, value: 10},
        {text: 20, value: 20},
        {text: 50, value: 50},
        {text: 100, value: 100},
        {text: 200, value: 200}
      ],
      fields: {
        first_name: {
          label: 'First Name',
          sortable: false
        },
        last_name: {
          label: 'Last Name',
          sortable: false
        },
        username: {
          label: 'Email address',
          sortable: false
        },
        mobile_number: {
          label: 'Contact Number',
          sortable: false
        },
        address_1postCode: {
          label: 'Address 1, Postcode',
          sortable: false
        },
        country: {
          label: 'Country',
          sortable: false
        },
        last_updated: {
          label: 'Last updated',
          sortable: false
        },
        action: {
          label: 'Action',
          tdClass: 'width-100'
        }
      },
      searchLabels: {
        first_name: 'First Name',
        last_name: 'Last Name',
        username: 'Email Address',
        country: 'Country'
      }
    }
  },
  mounted () {
    if (window.localStorage.getItem('token') === null) {
      this.$store.dispatch(APIEvent.LOGOUT, {})
    } else {
      this.fetchIncompleteInstallsListData()
    }
  },
  methods: {
    fetchIncompleteInstallsListData (offset, data) {
      if (this.typeSearch === null && this.searchInput !== '') {
        let message = 'Please select a search type before clicking on Apply.'
        EventBus.$emit(StatusBarEvent.ERROR, message)
      } else {
        data = data || {}
        data.start_record = typeof offset === 'undefined' ? '0' : offset.toString()
        this.startOffset = parseInt(data.start_record)
        data.fetch_size = this.perPage.toString()
        if (this.typeSearch !== null) {
          data[this.typeSearch] = this.searchInput.trim()
        }
        this.requestData = data
        this.$store.dispatch(APIEvent.FETCH_INCOMPLETE_INSTALLS_LIST, data)
          .then(this.fetchIncompleteInstallsEventResponseHandler)
          .catch(this.handleError)
      }
    },
    fetchIncompleteInstallsEventResponseHandler (res) {
      var records = res.data.list.records || []
      if (!records) return
      if (this.download) {
        this.downloadHandler(records)
        // should we continue to display the data here?
        // return
      }
      this.pageNumber = (this.startOffset / this.perPage) + 1
      this.incompleteInstallsList = records
      this.hasNextPage = res.data.LastPage === '0'
    },
    handleError (error) {
      let message = error.message
      switch (error.error) {
        case 205:
          this.errorString = 'Please enter search'
          break

        case 507:
          this.errorString = 'You are not permitted to view the customer profile'
          break

        case 511:
          this.errorString = 'LeakBot ID has not been paired with a registered customer account'
          break

        case 305:
          this.errorString = 'No matches found'
          break

        case 209:
          // eslint-disable-next-line no-case-declarations
          let prop = this.searchLabels[this.typeSearch]
          this.errorString = prop + ' is not in the expected format'
          break

        default:
          this.errorString = 'No matches found'
          break
      }
      error.message = message
      EventBus.$emit(StatusBarEvent.ERROR, error.message)
    },
    search () {
      /*
      if (!this.download) {
        this.resetTable()
      }
      */
      this.errorString = ''
      var dataSearch
      var message
      // var Regex='/^[^a-zA-Z]*$/'
      if (this.typeSearch === 'first_name') {
        dataSearch = {'first_name': this.searchInput.trim()}
      } else if (this.typeSearch === 'last_name') {
        dataSearch = {'last_name': this.searchInput.trim()}
      } else if (this.typeSearch === 'username') {
        dataSearch = {'username': this.searchInput.trim()}
      } else if (this.typeSearch === 'country') {
        if (this.searchInput.trim().length === 2 && /^[a-zA-Z]+$/.test(this.searchInput.trim())) {
          dataSearch = {'country': this.searchInput.trim()}
        } else {
          message = 'Please enter a valid country (2 alphabetical characters max) input before clicking on Apply.'
          EventBus.$emit(StatusBarEvent.ERROR, message)
        }
      }
      if (this.typeSearch !== null && this.searchInput.trim() !== '') {
        this.$store.dispatch(APIEvent.FETCH_INCOMPLETE_INSTALLS_LIST, dataSearch)
          .then((results) => {
            if (results.data.list.hasOwnProperty('records')) {
              this.incompleteInstallsList = results.data.list.records
              if (results.data.LastPage === '1') {
                this.pageNumber = 1
              } else {
                this.pageNumber = (this.startOffset / this.perPage) + 1
              }
              this.hasNextPage = results.data.LastPage === '0'
            } else {
              message = 'Please enter a valid search input before clicking on Apply.'
              this.incompleteInstallsList = []
              EventBus.$emit(StatusBarEvent.ERROR, message)
            }
          })
          .catch((error) => {
            this.reject(error)
          })
      } else if ((this.typeSearch === null && this.searchInput.trim() === '')) {
        var data = {}
        data.start_record = this.startOffset.toString()
        data.fetch_size = this.perPage.toString()
        this.$store.dispatch(APIEvent.FETCH_INCOMPLETE_INSTALLS_LIST, data)
          .then((results) => {
            if (results.data.list.hasOwnProperty('records')) {
              this.incompleteInstallsList = results.data.list.records
              if (results.data.LastPage === '1') {
                this.pageNumber = 1
              } else {
                this.pageNumber = (this.startOffset / this.perPage) + 1
              }
              this.hasNextPage = results.data.LastPage === '0'
            } else {
              this.incompleteInstallsList = []
              let message = 'No matches found.'
              EventBus.$emit(StatusBarEvent.ERROR, message)
            }
          })
          .catch((error) => {
            this.reject(error)
          })
      } else if (this.typeSearch === null && this.searchInput.trim() !== '') {
        this.incompleteInstallsList = []
        this.pageNumber = '1'
        this.errorString = 'Please select a search type before clicking on Apply.'
      } else if ((this.typeSearch !== null && this.searchInput.trim() === '') ||
        (this.typeSearch !== null && this.searchInput.trim() === '' && (dataSearch.first_name !== '' || dataSearch.last_name !== '' || dataSearch.username !== ''))) {
        data = {}
        data.start_record = this.startOffset.toString()
        data.fetch_size = this.perPage.toString()
        this.pageNumber = (this.startOffset / this.perPage) + 1
        this.$store.dispatch(APIEvent.FETCH_INCOMPLETE_INSTALLS_LIST, data)
          .then((results) => {
            if (results.data.list.hasOwnProperty('records')) {
              this.incompleteInstallsList = results.data.list.records

              this.hasNextPage = results.data.LastPage === '0'
            } else {
              this.incompleteInstallsList = []
              let message = 'Please enter a valid search input before clicking on Apply.'
              EventBus.$emit(StatusBarEvent.ERROR, message)
            }
          })
          .catch((error) => {
            this.reject(error)
          })
      }
    },
    getSearchProp (propName) {
      let props = {
        startOffset: 'start_record'
      }
      let retValue = props[propName]
      return retValue || propName
    },
    sanitiseSearchData (options) {
      let data = {'fetch_size': '20'}
      for (var prop in options) {
        if (typeof options[prop] !== 'undefined' && options[prop] !== '') {
          data[this.getSearchProp(prop)] = options[prop].toString()
        }
      }

      data.fetch_size = this.perPage.toString()
      this.incompleteInstallsList = []
      this.fetchIncompleteInstallsListData(this.startOffset, data)
    },
    page (event) {
      var next = event.currentTarget.className.indexOf('next') > -1
      if (next) {
        this.startOffset += this.perPage
      } else {
        this.startOffset -= this.perPage
      }
      this.fetchIncompleteInstallsListData(this.startOffset, this.requestData)
    },
    resetTable () {
      this.download = false
      this.perPage = 20
      this.startOffset = 0
      this.hasNextPage = false
      this.pageNumber = 1
      this.errorMessage = ''
    },
    downloadReport () {
      // This will get the first 200 from the leak list
      this.download = true
      // this.perPage = 200
      // eslint-disable-next-line no-self-assign
      this.perPage = this.perPage
      // pass the current start offset so entire records
      // can be manually downloaded
      // this.search()
      // this.fetchIncompleteInstallsListData(this.startOffset)
      // This just exports current data in view
      this.downloadHandler(this.incompleteInstallsList)
    },
    downloadHandler (records) {
      var headings = {
        first_name: 'First Name',
        last_name: 'Last Name',
        username: 'Email address',
        mobile_number: 'Contact Number',
        address_1: 'Address 1',
        postCode: 'Postcode',
        country: 'Country',
        last_updated: 'Last updated'
      }
      var JsonData = JSON.stringify(records)
      if (JsonData !== '') {
        var title = createReportLabel('Incomplete Installs List')
        JSONToCSVConvertor(JsonData, title, true, headings)
      } else {
        let message = 'The file can not be exported. Please check and try again.'
        EventBus.$emit(StatusBarEvent.ERROR, message)
      }
      this.download = false
    },
    onChange: function () {
      this.startOffset = 0
      this.pageNumber = 1
    },
    showUserDetails: function (data) {
      this.selectedUser = Object.assign({}, data.item)
      if (this.selectedUser.last_name === 'deleted' && this.selectedUser.username.includes('+deleted@old-')) {
        let message = 'This user has already been marked as deleted.'
        EventBus.$emit(StatusBarEvent.ERROR, message)
        return
      }
      this.selectedUser.last_name = this.selectedUser.last_name = 'deleted'
      this.selectedUser.username = this.selectedUser.username.replace('@', '+deleted@old-')
      this.$refs.markAsDisabledUserDetails.show()
    },
    markAsDisabled: function () {
      let options = {}
      options.account_id = this.selectedUser.id
      options.username = this.selectedUser.username
      options.last_name = this.selectedUser.last_name

      this.$store.dispatch(APIEvent.UPDATE_ACCOUNT, options)
        .then(() => {
          this.fetchIncompleteInstallsListData()
          EventBus.$emit(StatusBarEvent.SUCCESS, 'User marked as disabled')
        })
        .catch(this.handleError)
    }
  }
}
